import React from "@platform/react";
import { Component } from "@platform/react-storybook/Component";
import { Carousel } from "@platform/react-storybook/Component/Carousel";

import { Text } from "@front/components/Element/Text";
import { VectorAsset } from "@front/components/Element/Asset/Vector";
import { Button } from "@front/components/Element/Button";
// import { VirgoText } from "@front/components/Element/Text/Virgo";

import Rules from "./_rules.module.scss";
import {
    DEF_SCHOLARSHIP,
    DURATION_SCHOLARSHIP,
    NAME_SCHOLARSHIP,
    TYPE_SCHOLARSHIP,
    DIRECTION_SCHOLARSHIP,
} from "./types";
import type { PropTypesScholarship } from "./types";

export function SectionScholarship(props: PropTypesScholarship) {
    const { onClick, logos, ...rest } = props;
    const carousels = [
        { key: "1", dir: DIRECTION_SCHOLARSHIP[0], uuids: logos || [] }, //.slice(0, count) },
        // TODO: when we have more logos we 'll we add it
        // { key: "2", dir: DIRECTION_SCHOLARSHIOP_HOME_PAGE[1], uuids: logos || [] }, //.slice(count, count + count) },
        // { key: "3", dir: DIRECTION_SCHOLARSHIOP_HOME_PAGE[0], uuids: logos || [] }, //.slice(-count) },
    ] as const;
    return (
        <Component {...rest} name={NAME_SCHOLARSHIP} tag="div" type={TYPE_SCHOLARSHIP}>
            <Text className={Rules.title} preset="torreon" uuid="title-scholarships" />
            <Text raw className={Rules.title} preset="puebla" uuid="scholarships-mixin" />
            {carousels.map(({ key, dir, uuids }) => (
                <Carousel
                    key={key}
                    className={Rules.logos}
                    direction={dir}
                    duration={DURATION_SCHOLARSHIP}>
                    {uuids.map((uuid) => (
                        <VectorAsset key={uuid} fill="chile" uuid={uuid} />
                    ))}
                </Carousel>
            ))}

            <Button
                className={Rules.button}
                preset="nigeria"
                text="button-join"
                onClick={onClick}
            />
        </Component>
    );
}
SectionScholarship.defaultProps = DEF_SCHOLARSHIP;
